import * as React from "react";
import * as moment from "moment";
import * as cn from "classnames/bind";
import { UserOrderInformation } from "burde";
import * as styles from "./my-pages.css";
import { useResources } from "contexts/resource-context";

const cx = cn.bind(styles);

const titleCn = () =>
    cx({
        "col-3": true,
        boldText: true,
    });

const infoCn = () =>
    cx({
        "col-9": true,
    });

interface CalendarInfoProps {
    calendar: UserOrderInformation;
    onClick: () => any;
}

const CalendarInfo: React.SFC<CalendarInfoProps> = ({ calendar, onClick }) => {
    const resource = useResources();

    const { name, calendarId, startDate } = calendar;

    const formattedStartDate = moment(startDate).clone().format("MMMM YYYY");
    const startDateString =
        formattedStartDate.charAt(0).toUpperCase() +
        formattedStartDate.slice(1);

    return (
        <div className={"col-12 col-md-6 col-lg-4"}>
            <div
                className={"col-12"}
                onClick={() => onClick()}
                style={{
                    marginTop: 50,
                    border: "1px solid #E8E8E8",
                    cursor: "pointer",
                }}>
                <div className={"row"}>
                    <div
                        className={"col-6"}
                        style={{
                            backgroundColor: "#E8E8E8",
                            padding: "10px 10px 10px 10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                        {calendar.calendarThumbnailSvg ? (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: calendar.calendarThumbnailSvg || "",
                                }}
                            />
                        ) : (
                            <img
                                style={{ maxWidth: "100%" }}
                                src="images/logotype.svg"></img>
                        )}
                    </div>
                    <div
                        className={"col-6"}
                        style={{ padding: "10px 10px 10px 10px" }}>
                        <div className={"row"}>
                            <div className={`col-12 ${titleCn()}`}>
                                {resource.CalendarInfo_Calendar}
                            </div>
                            <div className={`col-12 ${infoCn()}`}>
                                {calendarId}
                            </div>
                        </div>
                        {name && (
                            <div className={"row"}>
                                <div className={titleCn()}>
                                    {resource.CalendarInfo_Name}
                                </div>
                                <div className={infoCn()}>{name}</div>
                            </div>
                        )}
                        <div className={"row"}>
                            <div className={`col-12 ${titleCn()}`}>
                                {resource.CalendarInfo_Ordered}
                            </div>
                            <div className={`col-12 ${infoCn()}`}>
                                {" "}
                                {moment(calendar.orderDate).isAfter(
                                    moment("2000-01-01"),
                                )
                                    ? moment
                                          .utc(calendar.orderDate)
                                          .local()
                                          .format("YYYY-MM-DD")
                                    : "-"}
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={`col-12 ${titleCn()}`}>
                                {resource.CalendarInfo_StartingMonth}
                            </div>
                            <div className={`col-12 ${infoCn()}`}>
                                {" "}
                                {startDateString}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CalendarInfo;
